import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  where
} from "firebase/firestore";

import { db } from "../firebase";

export const CONTENT_REPORT_REASONS = [
  "Copyright or stolen content",
  "Harassment or bullying",
  "Impersonation",
  "Scam or misleading content",
  "Illegal or unsafe content",
  "Other",
];

export async function reportContent({
  reporterId,
  targetType,
  targetId,
  reason,
  details = "",
  targetUsername = ""
}) {
  if (!reporterId || !targetType || !targetId || !reason) {
    throw new Error("Missing report information.");
  }

  await addDoc(collection(db, "reports"), {
    reporterId,
    targetType,
    targetId,
    targetUsername,
    type: targetType,
    reason,
    details,
    status: "open",
    reviewed: false,
    createdAt: serverTimestamp()
  });
}

export async function blockUser({
  blockerId,
  blockedId,
  blockedUsername = ""
}) {
  if (!blockerId || !blockedId) {
    throw new Error("Missing block information.");
  }

  const blockId = `${blockerId}_${blockedId}`;

  await setDoc(doc(db, "blocks", blockId), {
    blockerId,
    blockedId,
    blockedUsername,
    createdAt: serverTimestamp()
  });
}

export async function getBlockedUserIds(userId) {
  if (!userId) return [];

  const blocksQuery = query(
    collection(db, "blocks"),
    where("blockerId", "==", userId)
  );

  const snapshot = await getDocs(blocksQuery);

  return snapshot.docs.map((item) => item.data().blockedId);
}